import { render, staticRenderFns } from "./PaymentMethodModal.vue?vue&type=template&id=397260ec&scoped=true&"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodModal.vue?vue&type=style&index=0&id=397260ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397260ec",
  null
  
)

export default component.exports